import React, { useState, useEffect}  from "react";

export function MessageModel(props){

  let [display, setDisplay] = useState("");
  let [message, setMessage] = useState("")
  let [messageType, setMessageType] = useState("")
  let [errorCls, setErrorCls] = useState({})
  useEffect(()=>{
    if(!props.success){
      setMessageType("Error")
      setMessage(props.message)
      setErrorCls({
        btn:"btn-danger",
        mainIcon:"fa-times",
        iconCls:"error"
      })
    }else{
      setMessage(props.message)
      setMessageType("Success")
      setMessage(props.message)
      setErrorCls({
        btn:"btn-success",
        mainIcon:"fa-check",
        iconCls:"success"
      })
    }

    if(props.message){
        setDisplay("block")
    }

  },[props.message, props.success])

  const btnEventHandel = () => {
    setDisplay("none")
    setMessageType("")
    setMessage("")
    setErrorCls({})
    if(typeof props.btnEvent !== "undefined"){
      props.btnEvent();
    }
  }

  return (
    <div className="modal fade show" style={{"display":display}}>
      <div className="modaloverlay show"></div>
      <div className="row">
        <div className="col-xl-4 col-md-6 mx-auto">
          <div className="panel mui-panel mui--z4 animated fadeInRight pl-4 pr-4">
            <div className={`icon-wrapper ${errorCls.iconCls}`}>
              <i className={`fas ${errorCls.mainIcon}`}></i>
            </div>
            <h1>{messageType}</h1>
            {
              Array.isArray(message) && message.length > 0?
                            
                <ul style={{"fontSize":"14px"}} className="list-group list-group-flush">
                  {
                    message.map((item, key)=>{
                      return (
                        <li key={key} className="list-group-item">{item}</li>      
                      )
                    })
                  }
                </ul>
                :<p>{message}</p>
            }
                        
            <button onClick={ ()=>btnEventHandel() } className={`btn-lg btn-block ${errorCls.btn}`}>OK</button>
          </div>
        </div>
      </div>
    </div>
  );
}